/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createRaster } from '../fn/raster-controller/create-raster';
import { CreateRaster$Params } from '../fn/raster-controller/create-raster';
import { deleteRaster } from '../fn/raster-controller/delete-raster';
import { DeleteRaster$Params } from '../fn/raster-controller/delete-raster';
import { getMeanValueForStressArea } from '../fn/raster-controller/get-mean-value-for-stress-area';
import { GetMeanValueForStressArea$Params } from '../fn/raster-controller/get-mean-value-for-stress-area';
import { getRaster } from '../fn/raster-controller/get-raster';
import { GetRaster$Params } from '../fn/raster-controller/get-raster';
import { getRasterForTunnelSection } from '../fn/raster-controller/get-raster-for-tunnel-section';
import { GetRasterForTunnelSection$Params } from '../fn/raster-controller/get-raster-for-tunnel-section';
import { getRasters } from '../fn/raster-controller/get-rasters';
import { GetRasters$Params } from '../fn/raster-controller/get-rasters';
import { getRastersFiltered } from '../fn/raster-controller/get-rasters-filtered';
import { GetRastersFiltered$Params } from '../fn/raster-controller/get-rasters-filtered';
import { getValueForCategory } from '../fn/raster-controller/get-value-for-category';
import { GetValueForCategory$Params } from '../fn/raster-controller/get-value-for-category';
import { getValueForCategoryCode } from '../fn/raster-controller/get-value-for-category-code';
import { GetValueForCategoryCode$Params } from '../fn/raster-controller/get-value-for-category-code';
import { getValueForRaster } from '../fn/raster-controller/get-value-for-raster';
import { GetValueForRaster$Params } from '../fn/raster-controller/get-value-for-raster';
import { mergeRaster } from '../fn/raster-controller/merge-raster';
import { MergeRaster$Params } from '../fn/raster-controller/merge-raster';
import { PageRasterDto } from '../models/page-raster-dto';
import { RasterDto } from '../models/raster-dto';
import { updateRaster } from '../fn/raster-controller/update-raster';
import { UpdateRaster$Params } from '../fn/raster-controller/update-raster';
import { uploadRaster } from '../fn/raster-controller/upload-raster';
import { UploadRaster$Params } from '../fn/raster-controller/upload-raster';

@Injectable({ providedIn: 'root' })
export class RasterControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRaster()` */
  static readonly GetRasterPath = '/v1/raster/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRaster()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRaster$Response(params: GetRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
    return getRaster(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRaster$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRaster(params: GetRaster$Params, context?: HttpContext): Observable<RasterDto> {
    return this.getRaster$Response(params, context).pipe(
      map((r: StrictHttpResponse<RasterDto>): RasterDto => r.body)
    );
  }

  /** Path part for operation `updateRaster()` */
  static readonly UpdateRasterPath = '/v1/raster/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRaster()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRaster$Response(params: UpdateRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
    return updateRaster(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRaster$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRaster(params: UpdateRaster$Params, context?: HttpContext): Observable<RasterDto> {
    return this.updateRaster$Response(params, context).pipe(
      map((r: StrictHttpResponse<RasterDto>): RasterDto => r.body)
    );
  }

  /** Path part for operation `deleteRaster()` */
  static readonly DeleteRasterPath = '/v1/raster/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRaster()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRaster$Response(params: DeleteRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteRaster(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRaster$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRaster(params: DeleteRaster$Params, context?: HttpContext): Observable<void> {
    return this.deleteRaster$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `mergeRaster()` */
  static readonly MergeRasterPath = '/v1/raster/merge/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mergeRaster()` instead.
   *
   * This method doesn't expect any request body.
   */
  mergeRaster$Response(params: MergeRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
    return mergeRaster(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mergeRaster$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mergeRaster(params: MergeRaster$Params, context?: HttpContext): Observable<RasterDto> {
    return this.mergeRaster$Response(params, context).pipe(
      map((r: StrictHttpResponse<RasterDto>): RasterDto => r.body)
    );
  }

  /** Path part for operation `getRasters()` */
  static readonly GetRastersPath = '/v1/raster';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRasters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRasters$Response(params?: GetRasters$Params, context?: HttpContext): Observable<StrictHttpResponse<PageRasterDto>> {
    return getRasters(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRasters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRasters(params?: GetRasters$Params, context?: HttpContext): Observable<PageRasterDto> {
    return this.getRasters$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageRasterDto>): PageRasterDto => r.body)
    );
  }

  /** Path part for operation `createRaster()` */
  static readonly CreateRasterPath = '/v1/raster';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRaster()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRaster$Response(params: CreateRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
    return createRaster(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRaster$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRaster(params: CreateRaster$Params, context?: HttpContext): Observable<RasterDto> {
    return this.createRaster$Response(params, context).pipe(
      map((r: StrictHttpResponse<RasterDto>): RasterDto => r.body)
    );
  }

  /** Path part for operation `getRastersFiltered()` */
  static readonly GetRastersFilteredPath = '/v1/raster/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRastersFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getRastersFiltered$Response(params: GetRastersFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageRasterDto>> {
    return getRastersFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRastersFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getRastersFiltered(params: GetRastersFiltered$Params, context?: HttpContext): Observable<PageRasterDto> {
    return this.getRastersFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageRasterDto>): PageRasterDto => r.body)
    );
  }

  /** Path part for operation `uploadRaster()` */
  static readonly UploadRasterPath = '/v1/raster/importRaster';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadRaster()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadRaster$Response(params: UploadRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
    return uploadRaster(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadRaster$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadRaster(params: UploadRaster$Params, context?: HttpContext): Observable<RasterDto> {
    return this.uploadRaster$Response(params, context).pipe(
      map((r: StrictHttpResponse<RasterDto>): RasterDto => r.body)
    );
  }

  /** Path part for operation `getValueForRaster()` */
  static readonly GetValueForRasterPath = '/v1/raster/value/raster/{id}/{x}/{y}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValueForRaster()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValueForRaster$Response(params: GetValueForRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return getValueForRaster(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValueForRaster$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValueForRaster(params: GetValueForRaster$Params, context?: HttpContext): Observable<number> {
    return this.getValueForRaster$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getMeanValueForStressArea()` */
  static readonly GetMeanValueForStressAreaPath = '/v1/raster/value/mean/{code}/{stressAreaId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeanValueForStressArea()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeanValueForStressArea$Response(params: GetMeanValueForStressArea$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return getMeanValueForStressArea(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeanValueForStressArea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeanValueForStressArea(params: GetMeanValueForStressArea$Params, context?: HttpContext): Observable<number> {
    return this.getMeanValueForStressArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getValueForCategoryCode()` */
  static readonly GetValueForCategoryCodePath = '/v1/raster/value/code/{code}/{x}/{y}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValueForCategoryCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValueForCategoryCode$Response(params: GetValueForCategoryCode$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return getValueForCategoryCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValueForCategoryCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValueForCategoryCode(params: GetValueForCategoryCode$Params, context?: HttpContext): Observable<number> {
    return this.getValueForCategoryCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getValueForCategory()` */
  static readonly GetValueForCategoryPath = '/v1/raster/value/category/{id}/{x}/{y}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValueForCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValueForCategory$Response(params: GetValueForCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return getValueForCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValueForCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValueForCategory(params: GetValueForCategory$Params, context?: HttpContext): Observable<number> {
    return this.getValueForCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getRasterForTunnelSection()` */
  static readonly GetRasterForTunnelSectionPath = '/v1/raster/rasterexport/{sectionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRasterForTunnelSection()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRasterForTunnelSection$Response(params: GetRasterForTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getRasterForTunnelSection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRasterForTunnelSection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRasterForTunnelSection(params: GetRasterForTunnelSection$Params, context?: HttpContext): Observable<any> {
    return this.getRasterForTunnelSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
